export default "__VITE_ASSET__7a401cc3__"